import cosmosConfig from './cosmosConfig.json'
import defaultConfig from './defaultConfig.json'
import monaConfig from './monaConfig.json'
import publicConfig from './public.json'
import tyrConfig from './tyrConfig.json'

export default {
	cosmosConfig,
	defaultConfig,
	monaConfig,
	tyrConfig
}
